export default {
  max_content_width: 1200,
  max_text_width: 500,

  transitions: {
    basic: '.25s ease-in-out'
  },

  headerHeight: 70,

  colors: {
    blue: '#2F4361',
    dark_blue: '#222f44',
    light_blue: '#415573',
    gold: '#DAB777',
    dark_gold: '#cca764',
    grey: '#828282',
    light_grey: '#C4C4C4',
    lightest_grey: '#F4F4F4',
  },

  breakpoints: {
    tablet: '@media screen and (max-width: 992px) ',
    phone: '@media screen and (max-width: 576px) '
  }
}



// WEBPACK FOOTER //
// /src/styles/variables.js